import { CLOSE_MODAL, OPEN_MODAL } from "./types";

const initialState = {
  isOpen: false, // Initial state is closed
};

const modalReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false, // This should update the state to close the modal
      };
    default:
      return state;
  }
};

export default modalReducer;
